<div class="pages-body login-page flex flex-column">
    <div class="align-self-center mt-auto mb-auto">
        <div class="pages-panel card flex flex-column">
            <div class="pages-header px-3 py-1">
                <h2>NEUES KENNWORT</h2>
            </div>

            <h4>{{applicationServiceExt.headerCaption}}</h4>

            <ng-container *ngIf="(isInLogin === false)">
                <div class="pages-detail mb-6 px-6">Bitte vergeben Sie ein neues Kennwort.</div>

                <div class="input-panel flex flex-column px-3">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-user"></i>
                        </span>
                        <span class="p-float-label">
                            <input type="password" id="password1" [(ngModel)]="password1" pInputText (keypress)="onInputKeyPressedAsync($event)">
                            <label for="password1">Kennwort</label>
                        </span>
                    </div>

                    <div class="p-inputgroup mt-3 mb-6">
                        <span class="p-inputgroup-addon">
                            <i class="pi pi-lock"></i>
                        </span>
                        <span class="p-float-label">
                            <input type="password" id="password2" [(ngModel)]="password2" pInputText (keypress)="onInputKeyPressedAsync($event)">
                            <label for="password2">Kennwort wiederholen</label>
                        </span>
                    </div>

                </div>

                <p-button class="login-button mb-6 px-3" label="LOGIN" [disabled]="(canLogin !== true)" (onClick)="loginAsync()"></p-button>
            </ng-container>
            <ng-container *ngIf="(isInLogin === true)">
                <div class="container-info">
                    <div>Die Anmeldedaten werden geprüft<br>und die Anwendung gestartet...</div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
<ngx-loading [show]="(isBusy$ | async)" [config]="{backdropBorderRadius: '3px', fullScreenBackdrop: true}"></ngx-loading>
